module.exports = __webpack_public_path__ + "static/footer-bg-61e61976e8a4ea1e4ff698142517ef3a.png";